module.exports = "div.row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1; }\n\n:host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/row/row.component.scss
// module id = ./src/app/components/row/row.component.scss
// module chunks = main